module.exports = __webpack_public_path__ + "static/media/cart.1672cc51.svg";